module.exports = __webpack_public_path__ + "pnskfsquadron/img/en-slider-2.jpg?9deca7cd";